
(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Utils = {
        normalizeStockData: function (data) {
            if (!data) return [];
            return Array.isArray(data) ? data : Object.values(data);
        },

        getStockProperty: function (stock, property, defaultValue = 0) {
            return parseFloat(stock[property]) || defaultValue;
        },

        SORT_CONFIG: {
            alphabetical: {
                getValue: (stock) => (stock.ticker || '').toLowerCase(),
                useLocaleCompare: true
            },
            total_dollar_value_change: {
                getValue: (stock, holdings) => {
                    if (!holdings || !holdings[stock.ticker]) return null;
                    const h = holdings[stock.ticker];
                    const price = parseFloat(stock.price) || 0;
                    const totalCostBasis = parseFloat(h.price) || 0;
                    const qty = parseFloat(h.quantity) || 0;
                    return (price * qty) - totalCostBasis;
                }
            },
            price_change_dollar: {
                getValue: (stock) => parseFloat(stock.todaysChange) || 0
            },
            value_change: {
                getValue: (stock, holdings) => {
                    if (!holdings || !holdings[stock.ticker]) return null;
                    const h = holdings[stock.ticker];
                    const change = parseFloat(stock.todaysChange) || 0;
                    const qty = parseFloat(h.quantity) || 0;
                    return change * qty;
                }
            },
            total_percent_price_change: {
                getValue: (stock, holdings) => {
                    if (!holdings || !holdings[stock.ticker]) return null;
                    const h = holdings[stock.ticker];
                    const price = parseFloat(stock.price) || 0;
                    const totalCostBasis = parseFloat(h.price) || 0;
                    const qty = parseFloat(h.quantity) || 0;
                    if (totalCostBasis === 0) return 0;
                    return (((price * qty) - totalCostBasis) / totalCostBasis) * 100;
                }
            },
            price_change_percent: {
                getValue: (stock) => parseFloat(stock.todaysChangePerc) || 0
            }
        },

        sortStockData: function (data, option, order, holdings) {
            const sorted = [...data];
            const multiplier = order === 'asc' ? 1 : -1;
            
            const config = this.SORT_CONFIG[option];
            
            if (!config) return sorted;

            sorted.sort((a, b) => {
                const valA = config.getValue(a, holdings);
                const valB = config.getValue(b, holdings);

                const hasA = (valA !== null && valA !== undefined);
                const hasB = (valB !== null && valB !== undefined);
                
                if (hasA !== hasB) {
                    if (hasA) return -1;
                    return 1;
                }
                
                if (!hasA && !hasB) {
                     return (a.ticker || '').localeCompare(b.ticker || '');
                }

                if (config.useLocaleCompare) {
                    return valA.localeCompare(valB) * multiplier;
                }

                if (valA < valB) return -1 * multiplier;
                if (valA > valB) return 1 * multiplier;
                return 0;
            });

            return sorted;
        },

        getCurrentUsername: function () {
            let username = "";
            try {
                if (window.currentSession?.user) {
                    const u = window.currentSession.user;
                    if (u.user_metadata?.display_name) return u.user_metadata.display_name;
                    if (u.email) return u.email.split('@')[0];
                }
            } catch (e) {
                console.warn("Could not determine username:", e);
            }
            return username;
        },

        truncateInputDisplay: function (value, maxLength = 10) {
            if (!value) return '';
            const strVal = String(value);
            if (strVal.length > maxLength) {
                return strVal.substring(0, maxLength) + '...';
            }
            return strVal;
        }
    };

    window.WatchlistApp.Utils = Utils;
})();
